import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./VendorPage.css";


const VendorPage = () => {
  const { id: businessId } = useParams();
  const [vendors, setVendors] = useState([]);
  const [editingVendorId, setEditingVendorId] = useState(null);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: ""
  });
  const navigate = useNavigate();

  // ✅ FIX: useCallback so it's stable for useEffect
  const fetchVendors = useCallback(async () => {
    try {
      const { data } = await api.get(`/business/${businessId}/vendors`);
      setVendors(data);
    } catch (err) {
      console.error("Error fetching vendors:", err);
    }
  }, [businessId]);

  useEffect(() => {
    fetchVendors();
  }, [fetchVendors]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const addVendor = async () => {
    await api.post(`/business/${businessId}/vendors`, form);
    setForm({ name: "", email: "", phone: "", address: "" });
    fetchVendors();
  };

  const disableVendor = async (vendorId) => {
    await api.put(`/vendors/${vendorId}/disable`);
    fetchVendors();
  };

  const editVendor = (vendor) => {
  setForm({ ...vendor });
  setEditingVendorId(vendor.id);
};

const updateVendor = async () => {
  await api.put(`/vendors/${editingVendorId}`, form);
  setForm({ name: "", email: "", phone: "", address: ""});
  setEditingVendorId(null);
  fetchVendors();
};


  return (
    <div className="vendor-container">
    <button className="avg-cogs-btn save-btn" onClick={() => navigate(-1)}>
  ← Back
</button>
      <h3>Customers</h3>

      <div className="vendor-form">
        <input name="name" placeholder="Name" value={form.name} onChange={handleChange} />
        <input name="email" placeholder="Email" value={form.email} onChange={handleChange} />
        <input name="phone" placeholder="Phone" value={form.phone} onChange={handleChange} />
        <input name="address" placeholder="Address" value={form.address} onChange={handleChange} />
        
        
                {editingVendorId ? (
        <>
            <button onClick={updateVendor}>Update Customer</button>
            <button onClick={() => {
            setForm({ name: "", email: "", phone: "", address: "" });
            setEditingVendorId(null);
            }}>Cancel</button>
        </>
        ) : (
        <button onClick={addVendor}>Add Customer</button>
        )}

      </div>

      <table className="vendor-table">
        <thead>
          <tr>
            <th>Name</th>
            <th className="vendor-email">Email</th>
            <th className="vendor-phone">Phone</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {vendors.map((v) => (
            <tr key={v.id}>
              <td>{v.name}</td>
              <td className="vendor-email">{v.email}</td>
              <td className="vendor-phone">{v.phone}</td>
              <td>
                <button onClick={() => editVendor(v)}>✏️</button>
                <button onClick={() => disableVendor(v.id)}>🚫</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VendorPage;
